import { poiLabelIcon } from '../utils/makiPaths';
import { placeMarkerColors } from '../utils/placeType';
import type { PointOfInterestPlace } from '../utils/pointOfInterest';

/** The poi-label sprite: the same plate and glyph the map draws for the place. */
export function PlaceMark({
  place,
  className = 'size-[23px]',
}: {
  place: Pick<PointOfInterestPlace, 'maki' | 'placeClass'>;
  className?: string;
}) {
  const marker = placeMarkerColors(place.maki, place.placeClass);
  const icon = poiLabelIcon(place.maki);
  return (
    <svg viewBox="0 0 20 20" className={`shrink-0 ${className}`} aria-hidden>
      <path
        d={icon.plate}
        fill={marker.background}
        stroke={marker.foreground}
        strokeWidth={icon.plateStroke}
      />
      {icon.glyph ? (
        <path d={icon.glyph} fill={marker.foreground} transform={icon.transform ?? undefined} />
      ) : null}
    </svg>
  );
}
